import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { shouldShowEstDevelopmentCost, shouldShowPricingGuidance, isClosedDeal, shouldSeeReadyForLenderIntegration } from "../deal-settings-rows-logic";

export const rows = {
  title: {
    label: "General Info",
    isTitle: true
  },
  dealName:
  {
    label: "Deal Name",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.STRING, name: "name", variant: "filled", style: { width: "100%" } }
    ]
  },
  projectTypeId:
  {
    label: "Project Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "projectType",
        name: "projectTypeId",
        variant: "filled",
        parentId: "projectTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  pricingGuidance:
  {
    isVisible: data => shouldShowPricingGuidance(data),
    label: "Pricing Guidance",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.DOLLAR, name: "pricingGuidance", variant: "filled" }
    ]
  },
  estDevelopmentCost:
  {
    isVisible: data => shouldShowEstDevelopmentCost(data),
    label: "Estimated Development Cost",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.DOLLAR, name: "estDevelopmentCost", variant: "filled" }
    ]
  },
  targetClosingDate:
  {
    isVisible: data => !isClosedDeal(data),
    label: "Targeted Closing Date",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.DATE, name: "targetedClosing", variant: "filled" }
    ]
  }
};
